import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxMaskModule } from 'ngx-mask';
import Swal from 'sweetalert2';
import { ErrorHandleService } from '../../services/error-handle/error-handle.service';
import { ModalAtualizacaoCadastroService } from '../../services/modal-atualizacao-cadastro/modal-atualizacao-cadastro.service';

@Component({
  selector: 'app-modal-atualizacao-cadastro',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgxMaskModule],
  providers: [ModalAtualizacaoCadastroService],
  templateUrl: './modal-atualizacao-cadastro.component.html',
  styleUrl: './modal-atualizacao-cadastro.component.scss',
})
export class ModalAtualizacaoCadastroComponent {

  form: FormGroup = this.formBuilder.group({
    userID: ['', [Validators.required]],
    name: ['', [Validators.required]],
    telephone: ['', [Validators.required]],
    email: ['', [Validators.required, this.emailValidator]],
    position: ['', [Validators.required]],
    cargo: ['', [Validators.required]],
    cellphone: ['', [Validators.required]],
  });
  submitted = false;

  companyId: any;
  restrictionKey: any;
  userId: any;

  cargos: any = [
    {
      cargo: 'Diretor(a) Comercial',
    },
    {
      cargo: 'Gerente Comercial',
    },
    {
      cargo: 'Representante Comercial',
    },
    {
      cargo: 'Assistente Comercial',
    },
    {
      cargo: 'Vendedor(a)',
    },
    {
      cargo: 'Propriet\u00E1rio(a)',
    },
    {
      cargo: 'Outro(a)',
    },
  ];
  cargo: any = '';

  constructor(
    public bsModalRef: BsModalRef,
    private readonly formBuilder: FormBuilder,
    protected readonly _pedagioService: ModalAtualizacaoCadastroService,
    private readonly _errorHandleService: ErrorHandleService
  ) {
    this.companyId = localStorage.getItem('companyID');
    this.restrictionKey = localStorage.getItem('restrictionKey');
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.form.get('userID').patchValue(parseInt(this.userId));
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  emailValidator(control: FormControl): { [key: string]: any } | null {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const valid =
      typeof control.value === 'string' && emailRegex.test(control.value);
    return valid ? null : { email: { valid: false } };
  }

  verificaCargo(cargo) {
    if (cargo.target.value !== 'Outro(a)') {
      this.form.get('position').patchValue(cargo.target.value);
    } else {
      this.form.get('position').patchValue('');
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this._pedagioService
      .atualizarUsuario(this.companyId, this.restrictionKey, this.form.value)
      .subscribe(
        (response) => {
          Swal.fire('', 'Dados atualizados com sucesso!', 'success').then(
            () => {
              this.bsModalRef.hide();
            }
          );
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }
}
